// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/styles/nomalize.less'
import '@/assets/styles/fn.less'
import '@/icons' // 图标
import '@/directivies'
import { FlexBox, FlexItem } from '@/components/flexbox'

import VueTouch from 'vue-touch'

Vue.component(FlexBox.name, FlexBox)
Vue.component(FlexItem.name, FlexItem)
Vue.use(VueTouch, {name: 'v-touch'})

const FastClick = require('fastclick')
FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js